import React from 'react';
import PropTypes from 'prop-types';

import StyledSelect from 'components/ui/StyledReactSelect';

const DiscountCard = ({ discountCards, onSelect, value, intl: { formatMessage } }) => {
  const options = [
    { label: formatMessage({ id: 'bookingMagnet.none' }), value: null },
    ...(discountCards?.map(({ code: value = '', name: label = '' }) => ({
      value,
      label
    })) || [])
  ];

  const handleChange = (newValue) => onSelect({ value: newValue.value, name: newValue.label });

  return (
    <StyledSelect
      id="discount-card-select"
      name="discount-card-select"
      className="react-select-container"
      classNamePrefix="react-select"
      width="200px"
      height="30px"
      mr="8px"
      options={options}
      value={options.find((o) => o.value === value)}
      onChange={handleChange}
    />
  );
};

DiscountCard.propTypes = {
  discountCards: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string
    })
  ),
  onSelect: PropTypes.func,
  value: PropTypes.string,
  intl: PropTypes.shape({ formatMessage: PropTypes.func })
};

export default DiscountCard;
